module.exports = __webpack_public_path__ + "static/media/065-eritrea.f43bdddf.svg";